var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummertree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 828,
    viewBox: "0 0 416 828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30453_32027)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.209 301.377C183.53 307.305 193.179 325.906 193.179 325.906C193.179 325.906 226.389 325.906 218.972 325.906C211.555 325.906 198.105 341.067 198.105 341.067C198.105 341.067 208.889 371.949 206.076 365.597C203.263 359.245 185.209 350.436 185.209 350.436C185.209 350.436 160.797 369.245 164.343 365.597C167.889 361.949 172.313 341.067 172.313 341.067C172.313 341.067 147.389 322.949 151.447 325.906C155.505 328.864 177.239 325.906 177.239 325.906C177.239 325.906 186.889 295.449 185.209 301.377Z",
    fill: "#DB222E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.875 533.383C240.998 535.777 239.459 548.417 239.459 548.417C239.459 548.417 256.127 559.827 252.405 557.279C248.682 554.73 236.729 557.709 236.729 557.709C236.729 557.709 231.545 576.895 232.313 572.744C233.081 568.594 227.042 557.976 227.042 557.976C227.042 557.976 208.335 559.017 211.367 558.407C214.398 557.796 223.784 548.848 223.784 548.848C223.784 548.848 217.491 531.203 218.513 534.08C219.534 536.957 231.458 542.941 231.458 542.941C231.458 542.941 246.752 530.988 243.875 533.383Z",
    fill: "#DB222E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89 63.111C49.4 11.911 13.1667 1.7777 0 3.11103L-8.5 798.611C8 770.778 43.1 712.911 51.5 704.111C62 693.111 77.5 701.611 82 704.111L82.1844 704.214C86.9969 706.893 105.657 717.283 117.5 692.611C127.1 672.611 154.167 651.611 166.5 643.611L203.5 547.611V513.611L173.5 483.611L154.5 422.111L166.5 393.111L173.5 346.111L89 312.111L45.5 274.111L51.5 229.111L99.5 181.111L127.5 188.111C134.5 165.278 148.5 117.211 148.5 107.611C148.5 95.6111 117.5 77.611 89 63.111Z",
    fill: "url(#paint0_linear_30453_32027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 36.6113C75.3333 45.1113 88.4 63.0113 114 66.6113C146 71.1113 144 99.6113 159 99.6113C174 99.6113 179 92.6113 190 99.6113C201 106.611 216.5 130.111 192 140.611C182 144.111 180.5 144.111 182.5 148.611C184.5 153.111 190.5 167.611 177 168.111C170.833 168.111 157.3 169.011 152.5 172.611C146.5 177.111 145 179.111 147.5 181.111C150 183.111 160 201.611 147.5 210.611C135 219.611 110.5 225.111 106.5 195.111C106 193.111 99 189.111 91.5 203.611C84 218.111 71.5 232.111 62 235.611C59.5 236.611 45.5 246.611 59.5 261.111C73.5 275.611 86 273.611 87.5 291.111C89 308.611 110 305.611 118 306.111C126 306.611 166.5 329.611 173.5 330.611C180.5 331.611 182.5 340.611 181.5 355.611C180.5 370.611 188.5 365.611 187 379.111C185.5 392.611 169.5 392.611 166 400.611C162.5 408.611 154 416.111 163 424.111C172 432.111 165.5 444.611 169.5 448.611C173.5 452.611 181 466.611 187 468.111C193 469.611 197 473.611 203.5 492.111C210 510.611 231.5 507.111 230.5 520.111C229.5 533.111 217.5 545.111 225 558.611C232.5 572.111 236 576.611 229 584.111C222 591.611 203 594.111 203.5 610.611C204 627.111 202 642.111 183 645.611C164 649.111 119.5 687.111 113.5 711.111C107.5 735.111 90 730.611 84 711.111C78 691.611 35.5 717.111 23.5 751.111L2 797.111V773.111C7.83333 767.611 19.9 754.311 21.5 745.111C23.5 733.611 56 680.111 80.5 700.611C105 721.111 119.5 679.611 111 670.111C104.911 663.306 93.1595 623.111 91.3297 620.611C89.5 618.111 87.5 608.611 90 610.611C92.5 612.611 125 663.111 157 616.111C162.5 607.111 166 585.111 147.5 586.611C129 588.111 111.5 588.611 113.5 572.611C115.5 556.611 152.5 533.611 134 509.111C115.5 484.611 93 532.611 49.5 539.111C14.7 544.311 3 565.945 1.5 576.111V541.611C24.8333 529.945 70.4 497.711 66 462.111C60.5 417.611 4.5 451.111 1.5 464.111V448.611V438.111C8.66667 434.111 24 423.811 28 414.611C30.5 410.611 39.1 402.211 53.5 400.611C71.5 398.611 83 358.111 59.5 355.611C36 353.111 34.5 367.611 25.5 367.111C16.5 366.611 4 350.611 7.5 330.611C10.3 314.611 4.66667 310.945 1.5 311.111V294.111C7.33333 300.445 20.3 313.111 25.5 313.111C32 313.111 46.5 297.611 46 291.111C45.5 284.611 34 277.611 31.5 261.111C29 244.611 34.5 219.611 33 214.111C31.5 208.611 31.5 196.111 44 192.611C56.5 189.111 77.5 179.611 92 169.611C94.7318 167.727 98.3509 165.985 102.47 164.292C97.3215 162.156 96.8597 159.764 97.5 158.611C99.8334 148.611 108.8 127.611 126 123.611C147.5 118.611 139 88.1113 106.5 84.1113C74 80.1113 91 64.6113 76.5 52.6113C64.9 43.0113 60.3333 32.9447 59.5 29.1113L72 36.6113Z",
    fill: "#F9FFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 461.612C161.4 468.812 149.333 458.945 143.5 453.112C141 448.112 154 448.612 157 451.612C160 454.612 165 452.612 163 461.612Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5002 332.112C96.5002 334.112 103.5 346.112 118.5 342.112C133.5 338.112 109 324.112 99.5002 332.112Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5002 287.612C59.5002 287.612 54.5002 273.112 54.5002 273.112C54.5002 273.112 51.9002 265.712 65.5002 270.112C82.5002 275.612 87.5002 290.112 81.5002 291.612C75.5002 293.112 81.5002 287.612 70.5002 287.612Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 129.611C185.3 124.011 188.334 118.611 190 116.611C192.581 112.111 188 112.111 196 111.111C204 110.111 201.5 131.111 193 136.111C184.5 141.111 188 136.611 186.5 129.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0002 392.611C104 373.411 128.5 383.611 140 391.111C120 408.611 132 440.611 138.5 451.111C129.5 451.111 117.5 499.611 95.0002 498.611C72.5002 497.611 80.0002 464.111 85.0002 451.111C90.0002 438.111 90.5002 416.611 98.0002 392.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5001 539.611C71.1001 550.011 74.8334 556.278 77.5001 558.111C97.9001 542.111 96.0001 528.445 92.5 523.611C90.1667 524.611 83.9001 529.211 77.5001 539.611Z",
    fill: "#F9FFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 550.111C142.6 549.711 139.5 554.111 135.5 557.611C131.5 561.111 124 567.111 126 574.611C128 582.111 148 578.611 158.5 570.611C169 562.611 157 550.611 149 550.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5 562.611C174.1 564.211 169.334 573.278 167.5 577.611C163.5 590.111 172 594.611 177.5 594.611C183 594.611 191.5 577.111 197 565.111C201.4 555.511 197.167 549.111 194.5 547.111C193.167 549.611 190.1 555.311 188.5 558.111C186.5 561.611 184 560.611 178.5 562.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.999 662.611C129.799 659.811 137.666 647.111 141.499 641.111C142.999 635.611 123.499 645.111 123.499 647.611C123.499 650.111 117.999 657.611 119.499 666.611C120.999 675.611 127.999 666.111 128.999 662.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 639.612C149.9 637.212 144.834 644.945 143 649.112C140.5 659.111 147 658.112 151.5 657.612C156 657.112 162.5 642.612 155.5 639.612Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 394.111C78.4 392.511 68 404.778 63 411.111C48 432.611 42 416.111 40 426.611C38 437.111 59.5 440.111 71 438.611C82.5 437.111 82 396.111 80 394.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 502.611C75.4 491.011 64.8333 497.111 60.5 501.611C57 505.611 53.5 506.611 53.5 512.111C53.5 524.111 64 519.611 70 516.111C76 512.611 92.5 517.111 83 502.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 321.612C19.1 318.812 17.1667 325.778 17 329.612C17 334.612 25.5 359.112 33.5 351.112C41.5 343.112 33.5 325.112 25.5 321.612Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 346.111C60.6001 350.911 52.0001 345.111 48.0001 341.611C44.0002 338.549 40.5001 339.611 39.5001 331.611C38.5001 323.611 46.5001 322.611 54.0001 331.611C61.5001 340.611 66.0001 340.111 63.0001 346.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 541.111C210 536.111 209 538.611 207.5 541.111C205.833 543.778 202.2 551.111 201 559.111C199.5 569.111 207.5 565.111 214 559.111C220.5 553.111 218 546.111 214 541.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5 586.112C188.9 588.512 188 592.778 188.5 594.612C189.7 597.011 200.333 589.945 205.5 586.112C201.166 590.112 193.5 598.212 197.5 598.612C202.5 599.112 210.5 582.112 209.5 579.612C208.5 577.112 206 583.112 196.5 586.112Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 628.111C192 642.111 178.333 638.611 172 635.111C168.754 633.611 170.5 624.611 183.5 616.611C196.5 608.611 201 610.611 196 628.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 497.611C171.4 512.011 181.667 518.611 186.5 520.111C188.5 520.611 186.5 526.111 181.5 523.111C176.5 520.111 173 523.111 169 523.111C165 523.111 166 526.111 176.5 532.111C187 538.111 189.5 534.111 188.5 541.611C184 550.111 175 548.111 159 541.611C143 535.111 143.5 532.111 145.5 520.111C147.5 508.111 144.5 501.111 139.5 491.611C134.5 482.111 149.5 475.111 154 474.611C158.5 474.111 166 479.611 169 497.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.501 408.111C133.701 408.111 133.334 411.111 133.501 412.611C133.501 422.111 134.901 439.111 140.5 431.111C147.5 421.111 140.001 408.111 136.501 408.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 488.611C173 486.111 173.5 487.611 173.5 492.611C175 505.111 188 515.111 190 506.611C192 498.111 181 491.111 177 488.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 527.111C200.5 529.911 196.833 534.277 195 536.111C186.5 528.611 192 523.611 193.5 522.111C195 520.611 200.5 523.611 200.5 527.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5 515.111C229.3 521.111 223.5 527.278 220 529.611C213.5 530.612 212 528.611 212 523.611C212 518.611 208.5 522.111 208 516.611C207.5 511.111 218.5 507.611 224.5 515.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5 581.112C225.7 587.512 220.667 578.112 218.5 572.612C215.897 567.112 221.5 564.612 224 563.112C226.5 561.612 232 573.112 228.5 581.112Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 318.611C45.1 312.611 46.8334 300.778 49 295.611C54.0001 290.611 53 302.611 60.5 316.611C68 330.611 82 322.111 90.5 335.111C99 348.111 113 349.111 121.5 347.111C130 345.111 130 354.611 135 354.611C140 354.611 152 365.611 148.5 376.111C145 386.611 126.5 364.611 113 363.111C99.5 361.611 75.5 371.111 74 354.611C72.5 338.111 68.5 326.111 55.5 318.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 254.112C32.5001 256.612 34.0001 241.612 35.5001 235.112C36.2318 231.112 38.6391 228.454 42.5002 229.612C47.5002 231.112 47.5001 251.612 40.0001 254.112Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 214.112C33.5 213.112 40.0001 203.612 44.0002 200.112C45.6669 198.445 50.0002 195.412 54.0002 196.612C59.0002 198.112 46.5002 215.112 40.0001 214.112Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0001 188.612C72.5001 187.112 81.0001 178.112 85.5001 178.112C89.5 178.112 93.0002 176.112 97.0002 179.612C101 183.112 85.5001 190.112 79.0001 188.612Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 347.611C135 348.111 132 345.611 132 343.611C131.488 342.111 132 340.111 139.5 337.111C147 334.111 157 342.111 158 353.111C159 364.111 150 359.611 149.5 356.611C149 353.611 144 347.111 139.5 347.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 375.111C182 359.611 167 369.611 167 375.111C167 378.111 163.5 379.111 165 383.611C166.5 388.111 170 388.111 170 391.111C170 394.111 184 390.611 183 375.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0001 307.611C65.0001 311.111 81.0001 323.611 81.5001 316.111C82.0001 308.611 64.5001 296.611 66.0001 307.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4999 219.111C60.4999 225.111 60.9999 218.111 61.9999 213.111C62.4503 210.111 67.5 204.111 77.5 203.611C87.5 203.111 80.4999 213.111 70.4999 219.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 179.611C112 185.111 105 182.111 104 174.111C102.616 169.611 112 166.111 114 167.611C116 169.111 112 174.111 112 179.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5 116.611C159.5 125.111 155 137.111 161.5 125.611C168 114.111 163.5 100.111 161.5 116.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 157.111C165.5 163.611 178.5 170.111 180 159.111C181.5 148.111 171 151.111 169 157.111Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 408.611C147 417.011 147.833 400.444 149 391.111C149.383 387.611 154 387.611 156.5 389.611C159 391.611 160.5 398.111 153 408.611Z",
    fill: "#BBE3EA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 158.611C74 152.045 72.7067 145.543 70.194 139.477C67.6812 133.411 63.9983 127.899 59.3553 123.256L44.0079 138.603C46.6354 141.231 48.7196 144.35 50.1416 147.783C51.5636 151.216 52.2954 154.896 52.2954 158.611H74Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 108.611C10.7392 108.611 -1.97851 113.879 -11.3553 123.256L3.9921 138.603C9.29853 133.297 16.4956 130.316 24 130.316V108.611Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-26 158.611C-26 171.872 -20.7322 184.59 -11.3553 193.967L3.9921 178.619C-1.31433 173.313 -4.29544 166.116 -4.29544 158.611H-26Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 208.611C37.2608 208.611 49.9785 203.343 59.3553 193.967L44.0079 178.619C38.7015 183.926 31.5044 186.907 24 186.907L24 208.611Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3553 123.256C49.9785 113.879 37.2608 108.611 24 108.611V130.316C31.5044 130.316 38.7015 133.297 44.0079 138.603L59.3553 123.256Z",
    fill: "#FEDA00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11.3553 123.256C-20.7322 132.633 -26 145.351 -26 158.611H-4.29544C-4.29544 151.107 -1.31432 143.91 3.9921 138.603L-11.3553 123.256Z",
    fill: "#FEDA00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11.3553 193.967C-1.97852 203.343 10.7392 208.611 24 208.611L24 186.907C16.4956 186.907 9.29852 183.926 3.9921 178.619L-11.3553 193.967Z",
    fill: "#FEDA00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_30453_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3553 193.967C68.7322 184.59 74 171.872 74 158.611L52.2954 158.611C52.2954 166.116 49.3143 173.313 44.0079 178.619L59.3553 193.967Z",
    fill: "#FEDA00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 186.611C27.2076 186.478 26.4384 186.327 25.6645 186.157C18.7489 184.628 12.5304 181.696 7.40177 177.508C2.29872 173.323 -1.76668 167.789 -3.50993 160.932C-3.70289 160.171 -3.86658 159.402 -4 158.611C-4.13326 159.402 -4.22285 160.197 -4.2665 161.005C-4.73539 168.314 -0.995421 175.895 4.86693 180.602C10.7038 185.406 18.4222 187.566 25.6161 186.916C26.4216 186.847 27.2076 186.745 28 186.611Z",
    fill: "#4581BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_30453_32027",
    x: 151,
    y: 300.611,
    width: 69.0518,
    height: 66.8462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_30453_32027",
    x: 211.034,
    y: 533.065,
    width: 41.9126,
    height: 41.2666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_30453_32027",
    x: 44.0078,
    y: 123.256,
    width: 29.9922,
    height: 35.3555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_30453_32027",
    x: -11.3555,
    y: 108.611,
    width: 35.3555,
    height: 29.9922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_30453_32027",
    x: -26,
    y: 158.611,
    width: 29.9922,
    height: 35.3555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_30453_32027",
    x: 24,
    y: 178.619,
    width: 35.3555,
    height: 29.9922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 0 0.859563 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_30453_32027",
    x: 24,
    y: 108.611,
    width: 35.3555,
    height: 29.9922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.788235 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_30453_32027",
    x: -26,
    y: 123.256,
    width: 29.9922,
    height: 35.3555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.788235 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_30453_32027",
    x: -11.3555,
    y: 178.619,
    width: 35.3555,
    height: 29.9922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.918795 0 0 0 0 0.788853 0 0 0 0 0.00198433 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_30453_32027",
    x: 44.0078,
    y: 158.611,
    width: 29.9922,
    height: 35.3555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.788235 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_32027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30453_32027",
    x1: 203.5,
    y1: 400.806,
    x2: -186.5,
    y2: 400.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#178CA1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30453_32027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 828,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummertree);
export default __webpack_public_path__ + "static/media/Summertree.cb4732a654ed34a3228aede5781c5fec.svg";
export { ForwardRef as ReactComponent };